import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { parseNoticeText } from "../helpers/notice-text.helper";

interface INoticeBoxProps {
  text: string;
}

export const NoticeBox = ({ text }: INoticeBoxProps) => (
  // A pasted URL has no break opportunity and would otherwise push a phone layout sideways.
  <Alert severity="warning" sx={{ overflowWrap: "anywhere" }}>
    <AlertTitle>Wichtiger Hinweis</AlertTitle>
    {parseNoticeText(text)}
  </Alert>
);
